/**
 * Restock ETA: one batch request for all out-of-stock SKUs, then shows "Restock: M/D/YYYY" or "Out of Stock".
 * Shows "Loading ETA…" (and adds class .restock-eta-loading) while fetching.
 */
(function () {
  var RESTOCK_ETA_BATCH_API = 'https://truwear-eta-api.vercel.app/api/restock-eta-batch';
  var LOADING_TEXT = 'Loading ETA…';
  var LOADING_CLASS = 'restock-eta-loading';

  function formatEta(isoDate) {
    if (typeof isoDate !== 'string') return null;
    var parts = isoDate.split('-');
    if (parts.length !== 3) return null;
    var y = parts[0], m = parseInt(parts[1], 10), d = parseInt(parts[2], 10);
    if (isNaN(m) || isNaN(d)) return null;
    return m + '/' + d + '/' + y;
  }

  function run() {
    var cells = document.querySelectorAll('[data-restock-eta][data-variant-sku]');
    var bySku = {};
    cells.forEach(function (el) {
      var sku = (el.getAttribute('data-variant-sku') || '').trim();
      if (!sku) return;
      el.textContent = LOADING_TEXT;
      el.classList.add(LOADING_CLASS);
      if (!bySku[sku]) bySku[sku] = [];
      bySku[sku].push(el);
    });

    var skus = Object.keys(bySku);
    if (skus.length === 0) return;

    var query = 'skus=' + skus.map(function (s) { return encodeURIComponent(s); }).join(',');
    fetch(RESTOCK_ETA_BATCH_API + '?' + query)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        skus.forEach(function (sku) {
          var eta = data && data[sku];
          var text = 'Out of Stock';
          if (typeof eta === 'string') {
            var formatted = formatEta(eta);
            if (formatted) text = 'Restock: ' + formatted;
          }
          (bySku[sku] || []).forEach(function (el) {
            el.textContent = text;
            el.classList.remove(LOADING_CLASS);
          });
        });
      })
      .catch(function () {
        skus.forEach(function (sku) {
          (bySku[sku] || []).forEach(function (el) {
            el.textContent = 'Out of Stock';
            el.classList.remove(LOADING_CLASS);
          });
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
